<section class="content">
  <div class="container-fluid">
    <div class="block-header">
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <ul class="breadcrumb breadcrumb-style" hidden>
            <li class="breadcrumb-item">
              <h4 class="page-title">Create Prescription</h4>
            </li>
            <li
              *ngIf="currentUser.UserRoleId == 3 ||currentUser.UserRoleId == 4"
              class="breadcrumb-item bcrumb-1"
            >
              <a routerLink="/pharmacist/dashboard">
                <i class="fas fa-home"></i> Home</a
              >
            </li>
            <li
              *ngIf="currentUser.UserRoleId == 2"
              class="breadcrumb-item bcrumb-1"
            >
              <a routerLink="/doctor/dashboard">
                <i class="fas fa-home"></i> Home</a
              >
            </li>
            <li class="breadcrumb-item bcrumb-2">
              <a routerLink="/prescription/list/" onClick="return false;"
                >Prescription</a
              >
            </li>
            <li class="breadcrumb-item active">Create Prescription</li>
          </ul>
          <!-- Update Prescription -->
          <ul class="breadcrumb breadcrumb-style">
            <li class="breadcrumb-item">
              <h4 class="page-title">Create Prescription</h4>
            </li>
            <li
              *ngIf="currentUser.UserRoleId == 3 ||currentUser.UserRoleId == 4"
              class="breadcrumb-item bcrumb-1"
            >
              <a routerLink="/pharmacist/dashboard">
                <i class="fas fa-home"></i> Home</a
              >
            </li>
            <li
              *ngIf="currentUser.UserRoleId == 2"
              class="breadcrumb-item bcrumb-1"
            >
              <a routerLink="/doctor/dashboard">
                <i class="fas fa-home"></i> Home</a
              >
            </li>
            <li
              *ngIf="currentUser.UserRoleId == 2"
              class="breadcrumb-item bcrumb-2"
            >
              <a routerLink="/doctor/prescription/list/" onClick="return false;"
                >Prescription</a
              >
            </li>
            <li
              *ngIf="currentUser.UserRoleId == 3 ||currentUser.UserRoleId == 4"
              class="breadcrumb-item bcrumb-2"
            >
              <a routerLink="/doctor/prescription/list/" onClick="return false;"
                >Prescription</a
              >
            </li>
            <li class="breadcrumb-item active">Create Prescription</li>
          </ul>
        </div>
      </div>
    </div>
    <div class="row clearfix">
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
        <div [hidden]="!IsPatient" class="card">
          <div class="header">
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <div
                class="row p-b-10 justify-content-between prescription-header"
              >
                <h5 class="w-auto">SEARCH PATIENT</h5>
              </div>
              <div class="row p-t-5">
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                  <form
                    [formGroup]="patientSearchForm"
                    (ngSubmit)="GetPatientList()"
                  >
                    <div class="row">
                      <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3 col-12">
                        <mat-form-field
                          class="example-full-width"
                          appearance="outline"
                        >
                          <input
                            matInput
                            type="text"
                            placeholder="Patient Name"
                            formControlName="name"
                            [matAutocomplete]="auto"
                            required
                          />
                          <mat-autocomplete
                            #auto="matAutocomplete"
                            [displayWith]="displayFn"
                            (optionSelected)="selectedPatient($event)"
                          >
                            <mat-option
                              *ngFor="let patient of filteredUsers$ | async"
                              [value]="patient"
                            >
                              <span class="text-uppercase"
                                >{{ patient.FirstName }} {{ patient.LastName
                                }}</span
                              >
                            </mat-option>
                          </mat-autocomplete>
                          <mat-error
                            *ngIf="patientSearchForm.get('name').hasError('required')"
                          >
                            Please enter the patient name.
                          </mat-error>
                        </mat-form-field>
                      </div>
                      <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 pt-2">
                        <div class="custom-icon-wrapper icon-button-demo">
                          <button class="" color="primary" mat-mini-fab>
                            <mat-icon>search</mat-icon>
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
          <h6 [hidden]="!IsPatient" class="px-3 social-login-title">OR</h6>
          <div [hidden]="!IsPatient" class="body">
            <div class="row p-b-10 justify-content-between prescription-header">
              <h5 class="w-auto">ADD PATIENT</h5>
            </div>
            <!-- Create New user -->
            <form [formGroup]="patientSelectionForm" (ngSubmit)="AddPatient()">
              <div class="row">
                <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 mx-auto">
                  <div class="user-panel-registration">
                    <div class="image">
                      <img
                        *ngIf="patient.ProfilePictureId==null"
                        alt="User Image"
                        class="img-circle user-img-circle"
                        src="assets/images/user/patient-1.png"
                      />
                      <app-profile-pic
                        *ngIf="patient.ProfilePictureId!=null && fileObj==null"
                        [type]="'profile'"
                        [documentId]="patient.ProfilePictureId"
                      ></app-profile-pic>
                    </div>
                  </div>
                  <mat-form-field class="example-full-width">
                    <ngx-mat-file-input
                      formControlName="picture"
                      placeholder="Click here to upload profile picture"
                      accept=".png,.jpeg,.jpg"
                      (change)="uploadProfile($event)"
                    >
                    </ngx-mat-file-input>
                    <mat-icon matSuffix>cloud_upload</mat-icon>
                    <mat-error
                      *ngIf="
                        patientSelectionForm
                          .get('picture')
                          .hasError('required') ||
                        patientSelectionForm.get('picture').touched
                      "
                    >
                      Please select profile picture.
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
              <div class="row">
                <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4">
                  <mat-form-field
                    class="example-full-width"
                    appearance="outline"
                  >
                    <mat-label>First Name</mat-label>
                    <input
                      matInput
                      formControlName="firstName"
                      required
                      [maxLength]="15"
                      [minLength]="10"
                    />
                    <mat-error
                      *ngIf="patientSelectionForm.get('firstName').hasError('required')"
                    >
                      First Name is required
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4">
                  <mat-form-field
                    class="example-full-width"
                    appearance="outline"
                  >
                    <mat-label>Middle Name</mat-label>
                    <input
                      matInput
                      formControlName="middleName"
                      [maxLength]="15"
                      [minLength]="10"
                    />
                    <!-- <mat-error
                      *ngIf="patientSelectionForm.get('middleName').hasError('required')"
                    >
                      Middle Name is required
                    </mat-error> -->
                  </mat-form-field>
                </div>
                <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4">
                  <mat-form-field
                    class="example-full-width"
                    appearance="outline"
                  >
                    <mat-label>Last Name</mat-label>
                    <input
                      matInput
                      formControlName="lastName"
                      required
                      [maxLength]="15"
                      [minLength]="10"
                    />
                    <mat-error
                      *ngIf="patientSelectionForm.get('lastName').hasError('required')"
                    >
                      Last Name is required
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
              <div class="row">
                <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4">
                  <mat-form-field
                    class="example-full-width"
                    appearance="outline"
                  >
                    <mat-label>Age</mat-label>
                    <input
                      matInput
                      formControlName="age"
                      required
                      [maxLength]="3"
                      [appOnlyNumberDirective]="true"
                    />
                    <mat-error
                      *ngIf="patientSelectionForm.get('age').hasError('required')"
                    >
                      Age is required
                    </mat-error>
                    <mat-error
                      *ngIf="!patientSelectionForm.get('age').hasError('required') && patientSelectionForm.get('age').hasError('min')"
                    >
                      Age should be greater than 1
                    </mat-error>
                    <mat-error
                      *ngIf="!patientSelectionForm.get('age').hasError('required') && patientSelectionForm.get('age').hasError('max')"
                    >
                      Age should be less than 150
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4">
                  <mat-form-field
                    class="example-full-width"
                    appearance="outline"
                  >
                    <mat-label>Phone</mat-label>
                    <input
                      matInput
                      formControlName="phone"
                      [pattern]="constants.PHONE_REGEXP"
                      [maxLength]="10"
                    />
                    <!-- <mat-error
                      *ngIf="patientSelectionForm.get('phone').hasError('required')"
                    >
                      Phone is required
                    </mat-error> -->
                    <mat-error
                      *ngIf="patientSelectionForm.controls.phone?.errors?.pattern"
                    >
                      Please enter a valid Phone
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4">
                  <mat-form-field
                    class="example-full-width"
                    appearance="outline"
                  >
                    <mat-label>Email</mat-label>
                    <input
                      [pattern]="constants.EMAIL_REGEXP"
                      matInput
                      formControlName="email"
                      [maxLength]="30"
                    />
                    <!-- <mat-error
                      *ngIf="patientSelectionForm.get('email').hasError('required')"
                    >
                      Email is required
                    </mat-error> -->
                    <mat-error
                      *ngIf="patientSelectionForm.get('email').hasError('pattern')"
                    >
                      Email is invalid
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
              <div class="row">
                <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4">
                  <mat-form-field
                    class="example-full-width"
                    appearance="outline"
                  >
                    <mat-label>Gender</mat-label>
                    <mat-select formControlName="gender" required>
                      <mat-option value="M"> Male </mat-option>
                      <mat-option value="F"> Female </mat-option>
                    </mat-select>

                    <mat-icon matSuffix
                      >{{ patientSelectionForm.controls["gender"].value |
                      lowercase }}</mat-icon
                    >
                    <mat-error
                      *ngIf="patientSelectionForm.get('gender').hasError('required')"
                    >
                      Gender is required
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4">
                  <mat-form-field
                    class="example-full-width"
                    appearance="outline"
                  >
                    <mat-label>Insurance information </mat-label>
                    <input
                      matInput
                      formControlName="insuranceInformation"
                      [maxLength]="400"
                    />
                    <!-- <mat-icon matSuffix>face</mat-icon> -->
                  </mat-form-field>
                </div>

                <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4">
                  <mat-form-field
                    class="example-full-width"
                    appearance="outline"
                  >
                    <mat-label>Patient Identifier</mat-label>
                    <input
                      matInput
                      formControlName="patientIdentifier"
                      [maxLength]="100"
                    />
                    <!-- <mat-icon matSuffix>face</mat-icon> -->
                  </mat-form-field>
                </div>
              </div>
              <div class="row">
                <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4">
                  <mat-form-field
                    class="example-full-width"
                    appearance="outline"
                  >
                    <mat-label>Allergies</mat-label>
                    <textarea
                      matInput
                      formControlName="allergies"
                      [maxLength]="250"
                    ></textarea>
                    <!-- <mat-error
                      *ngIf="patientSelectionForm.get('allergies').hasError('required')"
                    >
                      Allergies is required
                    </mat-error> -->
                  </mat-form-field>
                </div>

                <div class="col-xl-8 col-lg-8 col-md-8 col-sm-8">
                  <mat-form-field
                    class="example-full-width"
                    appearance="outline"
                  >
                    <mat-label>Address</mat-label>
                    <textarea
                      [maxLength]="100"
                      matInput
                      formControlName="address"
                    ></textarea>
                    <!-- <mat-error
                      *ngIf="patientSelectionForm.get('address').hasError('required')"
                    >
                      Address is required
                    </mat-error> -->
                  </mat-form-field>
                </div>
              </div>
              <div class="row">
                <div class="col-xl-8 col-lg-8 col-md-8 col-sm-8 mb-8"></div>
                <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 mb-2">
                  <button class="btn btn-lg btn-primary w-100" type="submit">
                    Next
                  </button>
                </div>

                <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 mb-2">
                  <button
                    class="btn btn-lg btn-secondary w-100"
                    type="button"
                    (click)="CancelPrescription()"
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>

        <!-- Create Drug -->
        <div [hidden]="IsPatient" class="card">
          <div class="body">
            <div class="row">
              <div class="col-md-12">
                <div class="white-box">
                  <!-- <h4 class="d-flex justify-content-end">
                    <b class="">Prescription No: </b
                    ><span class=""> 345766</span>
                  </h4> -->
                  <hr />
                  <div class="row">
                    <div class="col-md-12">
                      <div class="pull-left">
                        <img
                          src="assets/images/prescription.png"
                          alt="logo"
                          class="logo-default"
                          height="100"
                        />
                      </div>
                      <div class="pull-right text-end">
                        <address>
                          <p class="font-24 font-bold m-0">
                            {{doctorDetails?.doctor.PracticeName}}
                          </p>
                          <p class="font-weight-500 m-0">
                            Dr.{{ currentUser.FirstName
                            }}&nbsp;{{currentUser.LastName}}
                          </p>
                          <p class="text-muted m-0 m-l-30">
                            {{currentUser.AddressLine1}}
                            <br />
                            {{currentUser.AddressLine2}}
                          </p>
                          <p class="text-muted m-l-30">
                            Phone No: {{currentUser.Phone}}
                          </p>
                        </address>
                      </div>
                    </div>
                    <!-- <div class="col-md-12">
                      <div class="pull-left">
                        <p class="addr-font-h3 font-bold">Patient Details</p>
                        <p class="text-muted m-l-5">
                          Name: John Doe (P-000048)<br />
                          Gender: Male<br />
                          Age: 35<br />
                          Phone: 1234567890
                        </p>
                      </div>
                      <div class="pull-right"></div>
                    </div> -->

                    <!-- <form
                      #createDrug="ngForm"
                      [formGroup]="createDrugForm"
                      (ngSubmit)="SaveDrug()"
                    >
                      <div class="row">
                        <div class="col-xl-10 col-lg-10 col-md-10 col-sm-10">
                          <div class="row">
                            <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3">
                              <mat-form-field class="example-full-width">
                                <input
                                  matInput
                                  type="text"
                                  placeholder="Drug"
                                  formControlName="drugName"
                                  (keyup)="onChange($event)"
                                  [matAutocomplete]="auto2"
                                  required
                                />
                                <mat-autocomplete
                                  #auto2="matAutocomplete"
                                  (optionSelected)="selectedDrug($event)"
                                  [displayWith]="displayFn2"
                                >
                                  <mat-option
                                    *ngFor="let drug of filteredDrugs$ | async"
                                    [value]="drug"
                                  >
                                    <span class="text-uppercase"
                                      >{{ drug.Name }}</span
                                    >
                                  </mat-option>
                                </mat-autocomplete>
                                <mat-error
                                  *ngIf="createDrugForm.get('drugName').hasError('required')"
                                >
                                  Please select the drug.
                                </mat-error>
                              </mat-form-field>
                            </div>
                            <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3">
                              <mat-form-field class="example-full-width">
                                <input
                                  matInput
                                  type="text"
                                  placeholder="Sig Code"
                                  formControlName="codeName"
                                  [matAutocomplete]="auto3"
                                />
                                <mat-autocomplete
                                  #auto3="matAutocomplete"
                                  (optionSelected)="selectedPrescriptionCode($event)"
                                  [displayWith]="displayFn3"
                                >
                                  <mat-option
                                    *ngFor="let code of filteredPrescriptionCode$ | async"
                                    [value]="code"
                                  >
                                    <span class="text-uppercase"
                                      >{{ code.Code }} | {{ code.Description
                                      }}</span
                                    >
                                  </mat-option>
                                </mat-autocomplete>
                              </mat-form-field>
                            </div>
                            <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3">
                              <mat-form-field class="example-full-width">
                                <mat-label>Description</mat-label>
                                <input
                                  matInput
                                  formControlName="description"
                                  required
                                />
                                <mat-error
                                  *ngIf="createDrugForm.get('description').hasError('required')"
                                >
                                  Description is required
                                </mat-error>
                              </mat-form-field>
                            </div>
                            <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3">
                              <mat-form-field class="example-full-width">
                                <mat-label>#Refill</mat-label>
                                <input
                                  [max]="10"
                                  [min]="0"
                                  type="number"
                                  matInput
                                  formControlName="refill"
                                  placeholder="No Of Refill"
                                />
                                <mat-error
                                *ngIf="createDrugForm.get('refill').hasError('min')"
                              >
                              #Refill should be greater than or equal to 0
                              </mat-error>
                                <mat-error
                                  *ngIf="createDrugForm.get('refill').hasError('max')"
                                >
                                #Refill should be less than or equal to 10
                                </mat-error>
                              </mat-form-field>
                            </div>
                          </div>
                        </div>
                        <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2" hidden>
                          <div class="custom-icon-wrapper icon-button-demo">
                            <button class="mt-2" color="primary" mat-mini-fab>
                              <mat-icon>add</mat-icon>
                            </button>
                            <button class="custom-button mt-2" mat-mini-fab>
                              <mat-icon>refresh</mat-icon>
                            </button>
                          </div>
                        </div>
                        <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2">
                          <div class="custom-icon-wrapper icon-button-demo">
                            <button class="mt-2" color="primary" mat-mini-fab>
                              <mat-icon>check</mat-icon>
                            </button>
                            <button
                              (click)="clearDrugForm()"
                              type="button"
                              class="custom-button mt-2"
                              mat-mini-fab
                            >
                              <mat-icon>close</mat-icon>
                            </button>
                          </div>
                        </div>
                      </div>
                    </form> -->
                    <form
                    #createDrug="ngForm"
                    [formGroup]="createDrugForm"
                    (ngSubmit)="SaveDrug()"
                  >
                    <div class="row">
                      <div class="col-xl-10 col-lg-10 col-md-10 col-sm-10">
                        <div class="row">
                          <div class="col-xl-5 col-lg-5 col-md-5 col-sm-5">
                            <mat-form-field class="example-full-width">
                              <input
                                matInput
                                type="text"
                                placeholder="Drug"
                                formControlName="drugName"
                                [matAutocomplete]="auto2"
                                required
                                (keyup)="onChange($event)"
                              />
                              <mat-autocomplete
                                #auto2="matAutocomplete"
                                (optionSelected)="selectedDrug($event)"
                                [displayWith]="displayFn2"
                              >
                                <mat-option
                                  *ngFor="let drug of filteredDrugs$ | async"
                                  [value]="drug"
                                >
                                  <span class="text-uppercase"
                                    >{{ drug.Name }}</span
                                  >
                                </mat-option>
                              </mat-autocomplete>
                              <mat-error
                                *ngIf="createDrugForm.get('drugName').hasError('required')"
                              >
                                Please select the drug.
                              </mat-error>
                            </mat-form-field>
                          </div>
                          <div class="col-xl-5 col-lg-5 col-md-5 col-sm-5">
                            <mat-form-field class="example-full-width">
                              <mat-label>#Refill</mat-label>
                              <input
                                [min]="0"
                                [max]="10"
                                type="number"
                                matInput
                                formControlName="refill"
                                placeholder="No Of Refill"
                              />
                              <mat-error
                                *ngIf="createDrugForm.get('refill').hasError('min')"
                              >
                                #Refill should be greater than or equal to 0
                              </mat-error>
                              <mat-error
                                *ngIf="createDrugForm.get('refill').hasError('max')"
                              >
                                #Refill should be less than or equal to 10
                              </mat-error>
                            </mat-form-field>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-xl-5 col-lg-5 col-md-5 col-sm-5">
                            <mat-form-field class="example-full-width">
                              <mat-chip-list
                                #chipList
                                aria-label="sigCode selection"
                              >
                                <mat-chip
                                  *ngFor="let sig of sighs"
                                  (removed)="remove(sig)"
                                >
                                  {{sig.Code}}
                                  <button matChipRemove>
                                    <mat-icon>cancel</mat-icon>
                                  </button>
                                </mat-chip>
                                <input #sigCodeInput
                                  matInput
                                  type="text"
                                  placeholder="Sig Code"
                                  formControlName="codeName"
                                  [matAutocomplete]="auto3"
                                  [matChipInputFor]="chipList"
                                  [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                                >
                              </mat-chip-list>
                              <mat-autocomplete
                                #auto3="matAutocomplete"
                                (optionSelected)="selectedPrescriptionCode($event)"
                                [displayWith]="displayFn3">
                                <mat-option
                                  *ngFor="let code of filteredPrescriptionCode$ | async"
                                  [value]="code">
                                  <span class="text-uppercase"
                                    >{{ code.Code }} | {{ code.Description}}</span>
                                </mat-option>
                              </mat-autocomplete>
                            </mat-form-field>
                          </div>
                          <div class="col-xl-5 col-lg-5 col-md-5 col-sm-5">
                            <!-- {{ createDrugForm.get('description').value }} -->
                            <mat-form-field class="example-full-width">
                              <mat-label>Description</mat-label>
                              <mat-chip-list>
                                <mat-chip *ngFor="let newdist of this.discriptionArr">{{newdist}}
                              </mat-chip>
                            </mat-chip-list>

                              <textarea disabled="true" 
                                matInput
                                formControlName="description"
                                required
                                cols="10"
                                rows="5"
                              >
                            </textarea>
                              <mat-error
                                *ngIf="createDrugForm.get('description').hasError('required')">
                                Description is required
                              </mat-error>
                            </mat-form-field>
                          </div>
                        </div>
                      </div>
                      <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2" hidden>
                        <div class="custom-icon-wrapper icon-button-demo">
                          <button class="mt-2" color="primary" mat-mini-fab>
                            <mat-icon>add</mat-icon>
                          </button>
                          <button class="custom-button mt-2" mat-mini-fab>
                            <mat-icon>refresh</mat-icon>
                          </button>
                        </div>
                      </div>
                      <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2">
                        <div class="custom-icon-wrapper icon-button-demo">
                          <button class="mt-2" color="primary" mat-mini-fab>
                            <mat-icon>check</mat-icon>
                          </button>
                          <button
                            (click)="clearDrugForm()"
                            type="button"
                            class="custom-button mt-2"
                            mat-mini-fab
                          >
                            <mat-icon>close</mat-icon>
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                    <div class="col-md-12">
                      <div class="table-responsive">
                        <table class="table table-hover">
                          <thead>
                            <tr
                              class="text-center"
                              *ngIf="selectedDrugList.length === 0"
                            >
                              <td colspan="10">No Drug Added</td>
                            </tr>
                            <tr *ngIf="selectedDrugList?.length != 0">
                              <th class="text-center">Sr. No.</th>
                              <th>Drug</th>
                              <th class="">Description</th>
                              <th class="">#Refill</th>
                              <th class="">Status</th>
                              <th class="action-icon-min-width">Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              *ngFor="let drug of selectedDrugList; let i= index"
                            >
                              <td class="text-center">{{i+1}}</td>
                              <td>{{drug?.name}}</td>
                              <td>{{drug?.description}}</td>
                              <td>
                                {{(drug?.refill == null || drug?.refill ==
                                '')?'-':drug?.refill}}
                              </td>
                              <td>{{drug?.status}}</td>
                              <td class="action-icon-min-width">
                                <button mat-icon-button>
                                  <mat-icon (click)="editDrugConfirm(drug)"
                                    >edit</mat-icon
                                  >
                                </button>
                                <button mat-icon-button>
                                  <mat-icon (click)="deleteDrugConfirm(drug)"
                                    >delete</mat-icon
                                  >
                                </button>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div class="pull-left">
                        <p class="createdDate">
                          <i class="fa fa-calendar"></i><b> &emsp;Date :</b>
                          {{currentDate | date:'MM/dd/yy'}}
                        </p>
                      </div>
                      <div class="pull-right text-center">
                        <div class="col ml-3 float-left form-section p-0">
                          <span
                            class="d-flex font-size-7 justify-content-end mb-1"
                            >Using your mouse pad or finger, sign in the
                            rectangle</span
                          >
                          <div class="signature-wrapper">
                            <canvas
                              class="border-radius-5 signature-pad"
                              id="signature-pad"
                              style="touch-action: none;"
                            ></canvas
                            ><br />
                          </div>
                          <a
                            class="add-email float-right pointer txt"
                            id="clear"
                            (click)="clearSignature()"
                            style="cursor: pointer;"
                            >Clear Signature</a
                          >
                          <!-- <span
                            class="font-11 text-danger add-email float-right pointer margin-right-42"
                          >
                            Required
                          </span> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-md-12" [hidden]="IsPatient">
                      <div class="row">
                        <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2">
                          <button
                            class="btn btn-lg btn-primary w-100"
                            (click)="previous()"
                            type="button"
                          >
                            Previous
                          </button>
                        </div>

                        <div
                          class="col-xl-6 col-lg-6 col-md-6 col-sm-6 mb-6"
                        ></div>

                        <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2">
                          <button
                            class="btn btn-lg btn-primary w-100"
                            type="button"
                            (click)="CreatePrescription()"
                          >
                            Submit
                          </button>
                        </div>

                        <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2">
                          <button
                            class="btn btn-lg btn-secondary w-100"
                            (click)="CancelPrescription()"
                            type="button"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<ng-template #CancelPrescriptionComponent>
  <div class="row delete-confirm">
    <div class="col-sm-12 mb-3">
      You will lose your progress. <br />
      Are you sure you want to cancel this prescription? <br />
    </div>
    <div class="col-sm-12">
      <div class="row">
        <div class="col-sm-10">
          <button
            type="button"
            (click)="Back()"
            class="btn btn-sm btn-primary me-3"
          >
            Yes
          </button>
          <button
            type="button"
            (click)="closeDialog()"
            class="btn btn-sm btn-secondary"
          >
            No
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #DeleteDrugComponent>
  <div class="row delete-confirm">
    <div class="col-sm-12 mb-3">
      Are you sure you want to delete the drug<br />
      <span class="text-info text-capitalize">{{drugc.name}}</span>&nbsp;?
      <br />
    </div>
    <div class="col-sm-12">
      <div class="row">
        <div class="col-sm-10">
          <button
            type="button"
            (click)="deleteDrug(drugc)"
            class="btn btn-sm btn-primary me-3"
          >
            Yes
          </button>
          <button
            type="button"
            (click)="closeDialog()"
            class="btn btn-sm btn-secondary"
          >
            No
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #EditDrugComponent>
  <div class="row delete-confirm">
    <div class="col-sm-12 mb-3">
      Are you sure you want to edit the drug<br />
      <span class="text-info text-capitalize">{{drugc.name}}</span>&nbsp;?
      <br />
    </div>
    <div class="col-sm-12">
      <div class="row">
        <div class="col-sm-10">
          <button
            type="button"
            (click)="editDrug(drugc)"
            class="btn btn-sm btn-primary me-3"
          >
            Yes
          </button>
          <button
            type="button"
            (click)="closeDialog()"
            class="btn btn-sm btn-secondary"
          >
            No
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-template>
